var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1665826035434,
    className: "icon",
    viewBox: "0 0 1207 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 1671,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 235.7421875,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M702.22834 268.195887L753.371831 217.016227 651.04868 114.729245l-51.143491 51.143491L434.032453 331.745472 268.195887 165.872736 217.016227 114.729245 114.729245 217.016227l51.143491 51.17966L331.745472 434.032453l-165.872736 165.872736L114.729245 651.04868 217.016227 753.408l51.17966-51.17966L434.032453 536.391773l165.872736 165.836567L651.04868 753.408 753.408 651.04868l-51.17966-51.143491L536.391773 434.032453l165.836567-165.836566z",
    "p-id": 1672
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.81e1059261053aaedb3450a2e3c7c025.svg";
export { ForwardRef as ReactComponent };